import React, { Component } from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';

export class InputPercentage extends Component {
  static propTypes = {
    inputid: PropTypes.string,
    inputplaceholder: PropTypes.string,
    inputname: PropTypes.string,
    maxlength: PropTypes.number,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    maxDecimals: PropTypes.number,
    clampMax: PropTypes.number,
  };

  static defaultProps = {
    inputid: '',
    inputplaceholder: '',
    inputname: '',
    maxlength: 6,
    value: '',
    onChange: undefined,
    maxDecimals: 2,
    clampMax: 100,
  };

  constructor(props) {
    super(props);
    const initial = (props.value != null ? String(props.value) : '');
    this.state = {
      value: this.formatPercentage(initial),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const next = (this.props.value != null ? String(this.props.value) : '');
      const formatted = this.formatPercentage(next);
      if (formatted !== this.state.value) {
        this.setState({ value: formatted });
      }
    }
  }

  formatPercentage = (input) => {
    const maxDecimals = this.props.maxDecimals;
    const clampMax = this.props.clampMax;

    if (input == null) return '';

    // normaliza: "." -> "," e mantém só dígitos e vírgula
    var s = String(input).trim().replace(/\./g, ',').replace(/[^\d,]/g, '');

    // preserva caso o usuário tenha digitado vírgula no fim (ex.: "12,")
    var trailingComma = s.endsWith(',');

    // mantém apenas a primeira vírgula
    var i = s.indexOf(',');
    if (i !== -1) {
      s = s.slice(0, i + 1) + s.slice(i + 1).replace(/,/g, '');
    }

    // caso especial: se o usuário digitou só "," queremos mostrar "0,"
    if (s === ',') return '0,';

    var parts = s.split(',');
    var whole = parts[0] || '';
    var decimal = parts[1] || '';

    // remove zeros à esquerda da parte inteira
    if (whole !== '') {
      var n = parseInt(whole, 10);
      whole = isNaN(n) ? '' : String(n);
    }

    // começou por vírgula (",5") -> "0,5"
    if (whole === '' && (decimal !== '' || trailingComma)) {
      whole = '0';
    }

    // limita casas decimais
    if (decimal.length > maxDecimals) {
      decimal = decimal.slice(0, maxDecimals);
    }

    // clamp 0..clampMax
    var nWhole = (whole === '' ? 0 : parseInt(whole, 10));
    if (!isNaN(nWhole) && nWhole > clampMax) {
      whole = String(clampMax);
      decimal = ''; // 100,xx não faz sentido
      trailingComma = false;
    }

    // se usuário digitou a vírgula no fim, preserva (ex.: "12," continua "12,")
    if (trailingComma && decimal === '') {
      return whole + ',';
    }

    return decimal ? (whole + ',' + decimal) : whole;
  };


  parseToNumber = (str) => {
    const clampMax = this.props.clampMax;
    if (!str) return null;
    var n = parseFloat(String(str).replace(/\./g, '').replace(',', '.'));
    if (isNaN(n)) return null;
    if (n < 0) n = 0;
    if (n > clampMax) n = clampMax;
    return n;
  };

  handleChange = (evt) => {
    const formatted = this.formatPercentage(evt.target.value);
    this.setState({ value: formatted });

    if (this.props.onChange) {
      const eventLike = {
        ...evt,
        target: {
          ...evt.target,
          value: formatted,
          name: (this.props.inputname || evt.target.name),
          id: (this.props.inputid || evt.target.id),
        },
      };
      this.props.onChange(eventLike, this.parseToNumber(formatted));
    }
  };

  handleBlur = () => {
    const formatted = this.formatPercentage(this.state.value);
    if (formatted !== this.state.value) {
      this.setState({ value: formatted });
      if (this.props.onChange) {
        const eventLike = {
          target: { value: formatted, name: this.props.inputname, id: this.props.inputid },
        };
        this.props.onChange(eventLike, this.parseToNumber(formatted));
      }
    }
  };

  render() {
    const { inputid, inputplaceholder, inputname, maxlength, ...rest } = this.props;
    const { value } = this.state;

    return (
      <div className="percentage">
        <Input
          {...rest}
          id={inputid}
          name={inputname}
          placeholder={inputplaceholder}
          className="form-control"
          type="text"
          inputMode="decimal"
          lang="pt-BR"
          pattern="^\d{1,3}(,\d{0,2})?$"
          maxLength={maxlength}
          value={value}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
        />
        <span className="btn-hover" />
      </div>
    );
  }
}

export default InputPercentage;
